import { gql } from '@apollo/client';

export const AGREE_TERMS_OF_SERVICE = gql`
  mutation AgreeTermsOfService {
    agreeTermsOfService
  }
`;
